import { ActionTree } from "vuex";
import { RootState } from "..";
import refereesApi from "../../api/referees.api";
import { RootActionTypes } from "./../root-actions";
import { RefereesState } from "./index";
import { RefereesMutationTypes } from "./referees.mutations";
import * as Sentry from "@/utils/logger.util";

export enum RefereesActionTypes {
  FetchReferees = "FETCH_REFEREES"
}

export const actions: ActionTree<RefereesState, RootState> = {
  async [RefereesActionTypes.FetchReferees]({ commit, dispatch }) {
    try {
      const response = await refereesApi.getReferees();
      commit(RefereesMutationTypes.SET_REFEREES, response.data.data);
    } catch (error) {
      Sentry.captureException(error);
      dispatch(RootActionTypes.HandleApiError, error, { root: true });
    }
  }
};
